import { render, staticRenderFns } from "./member_grade_add.vue?vue&type=template&id=158a82f7&scoped=true"
import script from "./member_grade_add.vue?vue&type=script&lang=js"
export * from "./member_grade_add.vue?vue&type=script&lang=js"
import style0 from "./member_grade_add.vue?vue&type=style&index=0&id=158a82f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a82f7",
  null
  
)

export default component.exports